<app-carousel>
  @for (link of data; let i = $index; track i) {
    <app-slide class="w-[600px] h-[600px]">
      <img [src]="link"
           [alt]="'slide-' + i"
           class="w-[600px] h-[600px]">
    </app-slide>
  }
  <app-slide class="w-[600px] h-[600px]">
    <app-gx-wrapped-feedback/>
  </app-slide>
</app-carousel>


<div class="buttonClose"
     mat-dialog-close
     [ngClass]="{'flex': (animationDone$ | ngrxPush)}">
  <mat-icon svgIcon="close"/>
</div>

<div class="disclaimer" [matTooltip]="'GX_WRAPPED.DISCLAIMER' | translate">
  <mat-icon svgIcon="help_outline"/>
</div>